import { withIsPreview } from '../../../types/fetch';
import { withHandle } from '../../../types/fetch';
import { 
  fetchByParams as fetchByParamsBase, 
} from "./helpers";

export async function fetchAll(isPreview = false) {
  const response = await fetchByParamsBase({
    isPreview,
    queryParams: /* groq */`_type == "collection"`,
  }) 

  return response
}

export async function fetchByHandle({ handle, isPreview = false, }: withHandle & withIsPreview) {
  const [response] = await fetchByParamsBase({
    isPreview,
    queryParams: /* groq */`_type == "collection" && store.slug.current == "${handle}"`,
  });

  return response
}